import { render, staticRenderFns } from "./PageDataMatrixSupport.vue?vue&type=template&id=feed64ee&scoped=true&"
import script from "./PageDataMatrixSupport.vue?vue&type=script&lang=js&"
export * from "./PageDataMatrixSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feed64ee",
  null
  
)

export default component.exports